export const BANNER_APP_IOS_URL = "https://apps.apple.com/th/app/topvalue-app/id1551086766";
export const BANNER_APP_ANDROID_URL = "https://play.google.com/store/apps/details?id=com.topvalue.android2";